interface HighlightProps {
  text: string;
  query: string;
}

export default function Highlight({ text, query }: HighlightProps) {
  const keyword = query.trim();
  if (!keyword) return <>{text}</>;

  const lowerText = text.toLowerCase();
  const lowerKey = keyword.toLowerCase();
  const parts: { value: string; match: boolean }[] = [];
  let cursor = 0;

  let index = lowerText.indexOf(lowerKey, cursor);
  while (index !== -1) {
    if (index > cursor) parts.push({ value: text.slice(cursor, index), match: false });
    parts.push({ value: text.slice(index, index + keyword.length), match: true });
    cursor = index + keyword.length;
    index = lowerText.indexOf(lowerKey, cursor);
  }
  if (cursor < text.length) parts.push({ value: text.slice(cursor), match: false });

  return (
    <>
      {parts.map((part, i) =>
        part.match ? (
          <mark key={i} className="bg-accent-200 text-accent-950 rounded-[2px] px-0.5">
            {part.value}
          </mark>
        ) : (
          <span key={i}>{part.value}</span>
        ),
      )}
    </>
  );
}